import React from "react";
import { Box, Flex } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
import { OnePassHelp } from "../../pure/OnePassHelp";
export const StatusDetailsRowZone = styled(Flex) `
  & {
    width: 100%;
    flex-wrap: wrap;
  }

  @media screen and (min-width: ${themeGet("breakpoints.xl")}) {
    & {
      width: 80%;
    }
  }
`;
export const StatusDetailsColumnZone = styled(Box) `
  & {
    width: 100%;
  }

  &:not(:first-of-type) {
    margin-top: ${themeGet("space.4")};
  }

  @media screen and (min-width: ${themeGet("breakpoints.md")}) {
    & {
      width: 70%;
    }
  }

  @media screen and (min-width: ${themeGet("breakpoints.lg")}) {
    & {
      width: 50%;
    }

    &:nth-of-type(odd) {
      padding-right: ${themeGet("space.6")};
    }

    &:nth-of-type(even) {
      padding-left: ${themeGet("space.6")};
    }

    &:not(:first-of-type) {
      margin-top: 0;
    }
  }

  @media screen and (min-width: ${themeGet("breakpoints.xl")}) {
    &:nth-of-type(odd) {
      padding-right: ${themeGet("space.10")};
    }

    &:nth-of-type(even) {
      padding-left: ${themeGet("space.10")};
    }
  }
`;
export const SubscriptionDetailsZone = ({ children }) => {
    return (<>
      <Box display={{ xs: "none", md: "block" }} position="absolute" top={{
            xs: 6,
            md: 8,
        }} right={{
            xs: 4,
            md: 8,
        }}>
        <OnePassHelp stacking/>
      </Box>
      {children}
      <Box my={8} display={{ xs: "block", md: "none" }}>
        <OnePassHelp />
      </Box>
    </>);
};
